import {Icon} from "../ui/icon";
import data from "./test.json";
import {useDrawer} from "@/contexts/DrawerContext";
import {Info} from "lucide-react";
import {DRAWER_IDS} from "@/components/Drawers";
import {useState} from "react";

import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/ui/tooltip";
import {LogEvent} from "@/types/logEvents";
import CallPlayer from "../ui/CallPlayer";
import {Switch} from "../ui/switch";
import Logs from "@/components/ui/Logs";

const RunTests = () => {
  const {Drawer, isDrawerOpen} = useDrawer();
  const DRAWER_ID = DRAWER_IDS.RUN_TESTS;
  const mockData = data[0];
  const [showEvents, setShowEvents] = useState(true);

  return (
    isDrawerOpen(DRAWER_ID) && (
      <Drawer id={DRAWER_ID}>
        <div className="flex flex-col h-full">
          <div className="flex flex-col gap-4 p-5 border-b">
            <CallPlayer />
            <label className="text-sm font-medium text-label flex items-center gap-2 cursor-pointer">
              <Switch
                checked={showEvents}
                onCheckedChange={() => {
                  setShowEvents(!showEvents);
                }}
                className="pointer-events-none bg-muted !opacity-100"
              />
              Show events
              <Tooltip delayDuration={0} disableHoverableContent={true}>
                <TooltipTrigger asChild>
                  <Icon className="w-4 h-4 border-0 text-disabled ml-1 cursor-pointer">
                    <Info />
                  </Icon>
                </TooltipTrigger>
                <TooltipContent side="bottom" sideOffset={10}>
                  <div className="flex flex-col gap-1 text-secondary">
                    <div>Show all events in the call.</div>
                  </div>
                </TooltipContent>
              </Tooltip>
            </label>
          </div>
          <div className="space-y-4 max-h-full overflow-y-auto p-5">
            <Logs events={mockData as LogEvent[]} showEvents={showEvents} />
          </div>
        </div>
      </Drawer>
    )
  );
};

export default RunTests;
